import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../../../../shared/components/AppButton";
import { AppUnderlinedTitle } from "../../../../../../../shared/components/AppUnderlinedTitle";
import { DownloadIcon } from "../../../../../../../shared/icons/DownloadIcon";

interface Props {
  handleExportFile: () => void;
  isDisabled: boolean;
  className?: string;
}

export const TranscriptHeader = ({
  handleExportFile,
  isDisabled,
  className,
}: Props) => {
  const { t } = useTranslation();

  return (
    <AppUnderlinedTitle leftContent={t("meetings.transcript")}>
      <AppButton
        buttonType={"text"}
        icon={<DownloadIcon />}
        onClick={handleExportFile}
        disabled={isDisabled}
      >
        {t("meetings.export_to_docx")}
      </AppButton>
    </AppUnderlinedTitle>
  );
};
